import React, { useState } from 'react';
import selectStyles from '../Select/Select.module.css';
import styles from './SearchSelect.module.css';
import useMenuSuspenso from './useMenuSuspenso';

const normalizar = (texto) => String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const agruparOpcoes = (opcoes) => opcoes.reduce((grupos, opcao) => {
    const nome = opcao.group ?? '';
    const existente = grupos.find((grupo) => grupo.nome === nome);
    if (existente) existente.opcoes.push(opcao);
    else grupos.push({ nome, opcoes: [opcao] });
    return grupos;
}, []);

export default function SearchSelect({
    label,
    value,
    options,
    onChange,
    onSearch,
    disabled,
    error,
    helperText,
    placeholder = '',
    searchPlaceholder = 'Buscar...',
    noOptionsText = 'Nenhuma opção encontrada',
    className,
}) {
    const { aberto, setAberto, wrapperRef } = useMenuSuspenso();
    const [termo, setTermo] = useState('');

    const selecionada = options.find((opcao) => opcao.value === value);
    const rotuloElevado = aberto || Boolean(selecionada) || Boolean(placeholder);
    const filtrarLocalmente = !onSearch;
    const visiveis = filtrarLocalmente && termo
        ? options.filter((opcao) => normalizar(opcao.label).includes(normalizar(termo)))
        : options;

    const alternarMenu = () => {
        if (aberto) {
            setAberto(false);
            return;
        }
        setTermo('');
        if (onSearch) onSearch('');
        setAberto(true);
    };

    const digitar = (evento) => {
        setTermo(evento.target.value);
        if (onSearch) onSearch(evento.target.value);
    };

    const selecionar = (opcao) => {
        onChange(opcao.value, opcao);
        setAberto(false);
    };

    return (
        <div className={`${selectStyles.wrapper} ${className || ''}`} ref={wrapperRef}>
            <button
                type="button"
                role="combobox"
                aria-expanded={aberto}
                disabled={disabled}
                className={`${selectStyles.campo} ${aberto ? selectStyles.campoAberto : ''} ${error ? selectStyles.campoComErro : ''}`}
                onClick={alternarMenu}
                onKeyDown={(evento) => evento.key === 'Escape' && setAberto(false)}
            >
                <span className={selectStyles.valor}>{selecionada?.label ?? placeholder}</span>
                <i className={`fa fa-chevron-down ${selectStyles.seta} ${aberto ? selectStyles.setaAberta : ''}`} />
            </button>

            {label && (
                <span className={`${selectStyles.rotulo} ${rotuloElevado ? selectStyles.rotuloElevado : ''} ${error ? selectStyles.rotuloComErro : ''}`}>
                    {label}
                </span>
            )}

            {aberto && (
                <div className={selectStyles.menu} role="listbox">
                    <div className={styles.busca}>
                        <input
                            autoFocus
                            type="text"
                            className={styles.buscaInput}
                            placeholder={searchPlaceholder}
                            value={termo}
                            onChange={digitar}
                            onKeyDown={(evento) => evento.key === 'Escape' && setAberto(false)}
                        />
                    </div>

                    {visiveis.length === 0 && <p className={styles.vazio}>{noOptionsText}</p>}

                    {agruparOpcoes(visiveis).map((grupo) => (
                        <React.Fragment key={grupo.nome}>
                            {grupo.nome && <p className={styles.grupo}>{grupo.nome}</p>}
                            {grupo.opcoes.map((opcao) => (
                                <button
                                    type="button"
                                    role="option"
                                    aria-selected={opcao.value === value}
                                    key={String(opcao.value)}
                                    className={`${selectStyles.opcao} ${opcao.value === value ? selectStyles.opcaoAtiva : ''}`}
                                    onClick={() => selecionar(opcao)}
                                >
                                    {opcao.label}
                                </button>
                            ))}
                        </React.Fragment>
                    ))}
                </div>
            )}

            {helperText && <p className={`${selectStyles.ajuda} ${error ? selectStyles.ajudaComErro : ''}`}>{helperText}</p>}
        </div>
    );
}
